import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=ce6cecc2&scoped=true"
import script from "./SendMessageDialog.vue?vue&type=script&lang=ts"
export * from "./SendMessageDialog.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDialog.vue?vue&type=style&index=0&id=ce6cecc2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6cecc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce6cecc2')) {
      api.createRecord('ce6cecc2', component.options)
    } else {
      api.reload('ce6cecc2', component.options)
    }
    module.hot.accept("./SendMessageDialog.vue?vue&type=template&id=ce6cecc2&scoped=true", function () {
      api.rerender('ce6cecc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/SendMessageDialog.vue"
export default component.exports